export const csts = Object.freeze({
  tributacao: {
    integral: '000',
    comAliquotasUniformes: '010',
    comAliquotasUniformesReduzidas: '011',
    monofasica: '620',
    emDeclaracaoDeRegimeEspecifico: '820',
  },
  aliquotas: {
    reduzida: '200',
    fixa: '220',
    fixaProporcional: '221',
  },
  reducao: {
    deAliquotaComRedutorDeBaseDeCalculo: '210',
    deBaseDeCalculo: '222',
  },
  isencao: '400',
  imunidadeENaoIncidencia: '410',
  diferimento: '510',
  suspensao: '550',
  transferenciaDeCredito: '800',
  ajuste: '810',
  exclusaoDeBaseDeCalculo: '830',
});

const ALIQUOTA_DEFAULTS = Object.freeze({
  IBS_UF: { valor: '0,1', padrao: 0.1 },
  IBS_MUN: { valor: '0', padrao: 0 },
  CBS: { valor: '0,9', padrao: 0.9 },
});

export const camposInfoAliquotasIbsCbs = [
  {
    ids: [
      'mov_estoque_nota_fiscal_p_ibs_uf',
      'classificacao_fiscal_parametros_classificacao_fiscal_attributes_p_ibs_uf',
      'parametros_generico_p_ibs_uf',
      'di_p_ibs_uf',
      'parametros_cliente_p_ibs_uf',
      'parametros_nota_fiscal_p_ibs_uf',
      'parametros_category_p_ibs_uf',
      'fiscal_ibs_aliquota_aliquota_uf'
    ],
    ...ALIQUOTA_DEFAULTS.IBS_UF
  },
  {
    ids: [
      'mov_estoque_nota_fiscal_p_ibs_mun',
      'classificacao_fiscal_parametros_classificacao_fiscal_attributes_p_ibs_mun',
      'parametros_generico_p_ibs_mun',
      'di_p_ibs_mun',
      'parametros_cliente_p_ibs_mun',
      'parametros_nota_fiscal_p_ibs_mun',
      'parametros_category_p_ibs_mun',
      'fiscal_ibs_aliquota_aliquota_mun'
    ],
    ...ALIQUOTA_DEFAULTS.IBS_MUN
  },
  {
    ids: [
      'mov_estoque_nota_fiscal_p_cbs',
      'classificacao_fiscal_parametros_classificacao_fiscal_attributes_p_cbs',
      'parametros_generico_p_cbs',
      'di_p_cbs',
      'parametros_cliente_p_cbs',
      'parametros_nota_fiscal_p_cbs',
      'parametros_category_p_cbs',
      'fiscal_cbs_aliquota_aliquota'
    ],
    ...ALIQUOTA_DEFAULTS.CBS
  }
];

export const camposInfoAliquotasIbsCbsEmMassa = [
  {
    ids: [
      'p_ibs_uf_em_massa',
    ],
    ...ALIQUOTA_DEFAULTS.IBS_UF
  },
  {
    ids: [
      'p_ibs_mun_em_massa',
    ],
    ...ALIQUOTA_DEFAULTS.IBS_MUN
  },
  {
    ids: [
      'p_cbs_em_massa',
    ],
    ...ALIQUOTA_DEFAULTS.CBS
  }
];

export const impostosIbsCbs = [
  {
    baseDeCalculo: 'mov_estoque_nota_fiscal_v_ibs_cbs_bc',
    aliquota: 'mov_estoque_nota_fiscal_p_ibs_uf',
    reducao: 'mov_estoque_nota_fiscal_p_reducao_ibs_uf',
    aliqEfetiva: 'mov_estoque_nota_fiscal_p_aliquota_ibs_uf_efetiva',
    valor: 'mov_estoque_nota_fiscal_v_ibs_uf',
    percentualDiferimento: 'mov_estoque_nota_fiscal_p_diferimento_ibs_uf',
    valorDiferimento: 'mov_estoque_nota_fiscal_v_diferimento_ibs_uf'
  },
  {
    baseDeCalculo: 'mov_estoque_nota_fiscal_v_ibs_cbs_bc',
    aliquota: 'mov_estoque_nota_fiscal_p_ibs_mun',
    reducao: 'mov_estoque_nota_fiscal_p_reducao_ibs_uf',
    aliqEfetiva: 'mov_estoque_nota_fiscal_p_aliquota_ibs_mun_efetiva',
    valor: 'mov_estoque_nota_fiscal_v_ibs_mun',
    percentualDiferimento: 'mov_estoque_nota_fiscal_p_diferimento_ibs_uf',
    valorDiferimento: 'mov_estoque_nota_fiscal_v_diferimento_ibs_mun'
  },
  {
    baseDeCalculo: 'mov_estoque_nota_fiscal_v_ibs_cbs_bc',
    aliquota: 'mov_estoque_nota_fiscal_p_cbs',
    reducao: 'mov_estoque_nota_fiscal_p_reducao_cbs',
    aliqEfetiva: 'mov_estoque_nota_fiscal_p_aliquota_cbs_efetiva',
    valor: 'mov_estoque_nota_fiscal_v_cbs',
    percentualDiferimento: 'mov_estoque_nota_fiscal_p_diferimento_cbs',
    valorDiferimento: 'mov_estoque_nota_fiscal_v_diferimento_cbs'
  }
];

export const seletoresParametrizacoes = {
  NCM: {
    cstSelect: 'classificacao_fiscal_parametros_classificacao_fiscal_attributes_ibs_cbs_situacao_tributaria_id',
    cClassTribSelect: 'classificacao_fiscal_parametros_classificacao_fiscal_attributes_ibs_cbs_classificacao_tributaria_id',
    cstRegularSelect: 'classificacao_fiscal_parametros_classificacao_fiscal_attributes_ibs_cbs_situacao_tributaria_regular_id',
    cClassTribRegularSelect: 'classificacao_fiscal_parametros_classificacao_fiscal_attributes_ibs_cbs_classificacao_tributaria_regular_id',
    containerSelector: '.container-informacoes-tributacao-regular-parametros-produtos',
    infoSelector: '.informacoes-tributacao-regular-parametros-produtos'
  },
  OPERACOES: {
    cstSelect: 'parametros_generico_ibs_cbs_situacao_tributaria_id',
    cClassTribSelect: 'parametros_generico_ibs_cbs_classificacao_tributaria_id',
    cstRegularSelect: 'parametros_generico_ibs_cbs_situacao_tributaria_regular_id',
    cClassTribRegularSelect: 'parametros_generico_ibs_cbs_classificacao_tributaria_regular_id',
    containerSelector: '.container-informacoes-tributacao-regular-parametros-genericos',
    infoSelector: '.informacoes-tributacao-regular-parametros-genericos'
  },
  CLIENTES: {
    cstSelect: 'parametros_cliente_ibs_cbs_situacao_tributaria_id',
    cClassTribSelect: 'parametros_cliente_ibs_cbs_classificacao_tributaria_id',
    cstRegularSelect: 'parametros_cliente_ibs_cbs_situacao_tributaria_regular_id',
    cClassTribRegularSelect: 'parametros_cliente_ibs_cbs_classificacao_tributaria_regular_id',
    containerSelector: '.container-informacoes-tributacao-regular-parametros-produtos',
    infoSelector: '.informacoes-tributacao-regular-parametros-produtos'
  },
  NOTAS_FISCAIS: {
    cstSelect: 'parametros_nota_fiscal_ibs_cbs_situacao_tributaria_id',
    cClassTribSelect: 'parametros_nota_fiscal_ibs_cbs_classificacao_tributaria_id',
    cstRegularSelect: 'parametros_nota_fiscal_ibs_cbs_situacao_tributaria_regular_id',
    cClassTribRegularSelect: 'parametros_nota_fiscal_ibs_cbs_classificacao_tributaria_regular_id',
    containerSelector: '.container-informacoes-tributacao-regular-parametros-produtos',
    infoSelector: '.informacoes-tributacao-regular-parametros-produtos'
  },
  CATEGORIAS: {
    cstSelect: 'parametros_category_ibs_cbs_situacao_tributaria_id',
    cClassTribSelect: 'parametros_category_ibs_cbs_classificacao_tributaria_id',
    cstRegularSelect: 'parametros_category_ibs_cbs_situacao_tributaria_regular_id',
    cClassTribRegularSelect: 'parametros_category_ibs_cbs_classificacao_tributaria_regular_id',
    containerSelector: '.container-informacoes-tributacao-regular-parametros-produtos',
    infoSelector: '.informacoes-tributacao-regular-parametros-produtos'
  }
};
